import React from "react";
// import { useNavigate } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left";
import { Button, Grid } from "@mui/material";
import CreateIcon from "@mui/icons-material/Create";
// import DeleteIcon from "@mui/icons-material/Delete";
import Tooltip from "@mui/material/Tooltip";
import ToggleButton from "@mui/material/ToggleButton";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import SearchIcon from "@mui/icons-material/Search";
import Pagination from "@mui/material/Pagination";
// import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";

function MasterCalculations() {
  // const navigate = useNavigate();

  const [selected, setSelected] = React.useState(false);

  const label = { inputProps: { "aria-label": "Size switch demo" } };

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Manage Apartment Type</h1>
            {/* <Button
              className="contentTopLefBt addCommiteeBt"
              onClick={() => navigate("/CreateInvoice")}
            >
              Create New Invoice
            </Button> */}
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              <div className="visitorListNewOut">
                <div className="visitorHead">Add Apartment Type</div>
                <div className="visitorListNewInner">
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={12}>
                      <label className="tabsLabel">Apartment Type</label>
                      <input
                        className="inputSt"
                        placeholder="Enter Apartment Type"
                      />
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <Button className="primaryBtn" style={{ float: "none" }}>
                        Submit
                      </Button>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <div className="visitorSearch">
                        <div className="visitorSearchDiv">
                          <SearchIcon className="visitorSearchIco" />
                          <input type="text" placeholder="Search" />
                        </div>
                        <div className="sortingIcoOut">
                          <ToggleButton
                            value="check"
                            selected={selected}
                            onChange={() => {
                              setSelected(!selected);
                            }}
                          >
                            <ImportExportIcon className="visitorFilterIco" />
                          </ToggleButton>
                        </div>
                      </div>

                      <div className="visitContDiv">
                        <div
                          className="visitCont1 resideNewContOut"
                          style={{ paddingLeft: 0 }}
                        >
                          <div className="visitContLeft">
                            <h3 className="visitContHed"> Bedroom Standard </h3>
                          </div>
                          <div className="resideNewCont">
                            <Tooltip title="Edit" placement="top" arrow>
                              <CreateIcon className="editBt" />
                            </Tooltip>
                            <Tooltip
                              title="Block / Unblock"
                              placement="top"
                              arrow
                            >
                              <Switch {...label} defaultChecked size="small" />
                            </Tooltip>
                          </div>
                        </div>
                      </div>

                      <div className="visitContDiv">
                        <div
                          className="visitCont1 resideNewContOut"
                          style={{ paddingLeft: 0 }}
                        >
                          <div className="visitContLeft">
                            <h3 className="visitContHed">
                              {" "}
                              Bedroom Garden Facing{" "}
                            </h3>
                          </div>
                          <div className="resideNewCont">
                            <Tooltip title="Edit" placement="top" arrow>
                              <CreateIcon className="editBt" />
                            </Tooltip>
                            <Tooltip
                              title="Block / Unblock"
                              placement="top"
                              arrow
                            >
                              <Switch {...label} defaultChecked size="small" />
                            </Tooltip>
                          </div>
                        </div>
                      </div>

                      <div className="visitContDiv">
                        <div
                          className="visitCont1 resideNewContOut"
                          style={{ paddingLeft: 0 }}
                        >
                          <div className="visitContLeft">
                            <h3 className="visitContHed"> Bedroom Lake Facing </h3>
                          </div>
                          <div className="resideNewCont">
                            <Tooltip title="Edit" placement="top" arrow>
                              <CreateIcon className="editBt" />
                            </Tooltip>
                            <Tooltip
                              title="Block / Unblock"
                              placement="top"
                              arrow
                            >
                              <Switch {...label} defaultChecked size="small" />
                            </Tooltip>
                          </div>
                        </div>
                      </div>

                      <div className="visitContDiv">
                        <div
                          className="visitCont1 resideNewContOut"
                          style={{ paddingLeft: 0 }}
                        >
                          <div className="visitContLeft">
                            <h3 className="visitContHed"> Bedroom Standard </h3>
                          </div>
                          <div className="resideNewCont">
                            <Tooltip title="Edit" placement="top" arrow>
                              <CreateIcon className="editBt" />
                            </Tooltip>
                            <Tooltip
                              title="Block / Unblock"
                              placement="top"
                              arrow
                            >
                              <Switch {...label} defaultChecked size="small" />
                            </Tooltip>
                          </div>
                        </div>
                      </div>

                      <div className="visitContDiv">
                        <div
                          className="visitCont1 resideNewContOut"
                          style={{ paddingLeft: 0 }}
                        >
                          <div className="visitContLeft">
                            <h3 className="visitContHed">
                              {" "}
                              Bedroom Garden Facing{" "}
                            </h3>
                          </div>
                          <div className="resideNewCont">
                            <Tooltip title="Edit" placement="top" arrow>
                              <CreateIcon className="editBt" />
                            </Tooltip>
                            <Tooltip
                              title="Block / Unblock"
                              placement="top"
                              arrow
                            >
                              <Switch {...label} defaultChecked size="small" />
                            </Tooltip>
                          </div>
                        </div>
                      </div>

                      <div className="visitContDiv">
                        <div
                          className="visitCont1 resideNewContOut"
                          style={{ paddingLeft: 0 }}
                        >
                          <div className="visitContLeft">
                            <h3 className="visitContHed"> Bedroom Lake Facing </h3>
                          </div>
                          <div className="resideNewCont">
                            <Tooltip title="Edit" placement="top" arrow>
                              <CreateIcon className="editBt" />
                            </Tooltip>
                            <Tooltip
                              title="Block / Unblock"
                              placement="top"
                              arrow
                            >
                              <Switch {...label} defaultChecked size="small" />
                            </Tooltip>
                          </div>
                        </div>
                      </div>

                      <div className="visitContDiv">
                        <div
                          className="visitCont1 resideNewContOut"
                          style={{ paddingLeft: 0 }}
                        >
                          <div className="visitContLeft">
                            <h3 className="visitContHed"> Bedroom Standard </h3>
                          </div>
                          <div className="resideNewCont">
                            <Tooltip title="Edit" placement="top" arrow>
                              <CreateIcon className="editBt" />
                            </Tooltip>
                            <Tooltip
                              title="Block / Unblock"
                              placement="top"
                              arrow
                            >
                              <Switch {...label} defaultChecked size="small" />
                            </Tooltip>
                          </div>
                        </div>
                      </div>

                      <div className="visitContDiv">
                        <div
                          className="visitCont1 resideNewContOut"
                          style={{ paddingLeft: 0 }}
                        >
                          <div className="visitContLeft">
                            <h3 className="visitContHed">
                              {" "}
                              Bedroom Garden Facing{" "}
                            </h3>
                          </div>
                          <div className="resideNewCont">
                            <Tooltip title="Edit" placement="top" arrow>
                              <CreateIcon className="editBt" />
                            </Tooltip>
                            <Tooltip
                              title="Block / Unblock"
                              placement="top"
                              arrow
                            >
                              <Switch {...label} defaultChecked size="small" />
                            </Tooltip>
                          </div>
                        </div>
                      </div>

                      <div className="visitContDiv">
                        <div
                          className="visitCont1 resideNewContOut"
                          style={{ paddingLeft: 0 }}
                        >
                          <div className="visitContLeft">
                            <h3 className="visitContHed"> Bedroom Lake Facing </h3>
                          </div>
                          <div className="resideNewCont">
                            <Tooltip title="Edit" placement="top" arrow>
                              <CreateIcon className="editBt" />
                            </Tooltip>
                            <Tooltip
                              title="Block / Unblock"
                              placement="top"
                              arrow
                            >
                              <Switch {...label} defaultChecked size="small" />
                            </Tooltip>
                          </div>
                        </div>
                      </div>

                      <div className="visitContDiv">
                        <div
                          className="visitCont1 resideNewContOut"
                          style={{ paddingLeft: 0 }}
                        >
                          <div className="visitContLeft">
                            <h3 className="visitContHed">
                              {" "}
                              Bedroom Standard Paint hourse{" "}
                            </h3>
                          </div>
                          <div className="resideNewCont">
                            <Tooltip title="Edit" placement="top" arrow>
                              <CreateIcon className="editBt" />
                            </Tooltip>
                            <Tooltip
                              title="Block / Unblock"
                              placement="top"
                              arrow
                            >
                              <Switch {...label} defaultChecked size="small" />
                            </Tooltip>
                          </div>
                        </div>
                      </div>

                      <div className="visitContDiv">
                        <div
                          className="visitCont1 resideNewContOut"
                          style={{ paddingLeft: 0 }}
                        >
                          <div className="visitContLeft">
                            <h3 className="visitContHed">
                              {" "}
                              Bedroom Garden Facing Paint hourse{" "}
                            </h3>
                          </div>
                          <div className="resideNewCont">
                            <Tooltip title="Edit" placement="top" arrow>
                              <CreateIcon className="editBt" />
                            </Tooltip>
                            <Tooltip
                              title="Block / Unblock"
                              placement="top"
                              arrow
                            >
                              <Switch {...label} defaultChecked size="small" />
                            </Tooltip>
                          </div>
                        </div>
                      </div>

                      <div className="visitContDiv">
                        <div
                          className="visitCont1 resideNewContOut"
                          style={{ paddingLeft: 0 }}
                        >
                          <div className="visitContLeft">
                            <h3 className="visitContHed">
                              {" "}
                              Bedroom Lake Facing Paint hourse{" "}
                            </h3>
                          </div>
                          <div className="resideNewCont">
                            <Tooltip title="Edit" placement="top" arrow>
                              <CreateIcon className="editBt" />
                            </Tooltip>
                            <Tooltip
                              title="Block / Unblock"
                              placement="top"
                              arrow
                            >
                              <Switch {...label} defaultChecked size="small" />
                            </Tooltip>
                          </div>
                        </div>
                      </div>

                      <div className="listPaginationMain">
                        <Pagination
                          count={10}
                          variant="outlined"
                          shape="rounded"
                        />
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default MasterCalculations;
